/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.209.1-v202610141927-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * A list of predicates by which to filter the items. Can include filters on item properties and filters using a hierarchy's source table column names.
 */
export interface PropertyFilterInputV1 {
    /**
     * The operator to apply on the provided property name
     */
    "operator": OperatorEnum;
    /**
     * The name of the item property to filter by
     */
    "propertyName": string;
    /**
     * The values to filter by. WITHIN and STRING_CONTAINS accept multiple values; other operators only allow one. Null values are only supported for EQUALS and WITHIN.
     */
    "values": Array<models.PropertyInputV1>;
}

export const OperatorEnum = {
    EQUALS: 'EQUALS',
    EQUALSIGNORECASE: 'EQUALS_IGNORE_CASE',
    NOTEQUALS: 'NOT_EQUALS',
    WITHIN: 'WITHIN',
    STRINGCONTAINS: 'STRING_CONTAINS',
    NOTSTRINGCONTAINS: 'NOT_STRING_CONTAINS',
    REGEXMATCHES: 'REGEX_MATCHES',
    NOTREGEXMATCHES: 'NOT_REGEX_MATCHES'
} as const;

export type OperatorEnum = typeof OperatorEnum[keyof typeof OperatorEnum];
